const firebaseConfig = {
    apiKey: "AIzaSyA1U6QnVHhn80m5clU6dAdviSF5bj9mXQ4",
    authDomain: "crypto-hub-65c9d.firebaseapp.com",
    projectId: "crypto-hub-65c9d",
    storageBucket: "crypto-hub-65c9d.appspot.com",
    messagingSenderId: "806413716995",
    appId: "1:806413716995:web:3d4d9db7f33c06cc310836"
  };

  export default firebaseConfig;